import {LatestArticles} from '../../partials/latest_articles';

window.addEventListener('load', () => {
  LatestArticles.onload();
});